import { useNavigate } from "react-router-dom";
import FeaturesSection from "./Features";
import { motion } from 'framer-motion';
import Footer from "../../Component/Fooder";

const HealthcareDataSecurity = () => {
    const navigate = useNavigate();

    return (
        <>
            {/* <div className="p-8  bg-gradient-to-t from-[#78ffa5] to-[#03ab3b]   w-full"> */}
            <div className="p-8  bg-white   w-full">
                {/* <h1 className=" mt-3 font-bold  text-white text-center mb-4 bg-gradient-to-r from-[#2a627a]  bg-opacity-100 backdrop-blur-lg p-4 rounded-lg  shadow-lg transition-all duration-300"></h1> */}
                <motion.div
                    initial={{ x: -200, opacity: 0 }}
                    animate={{ x: 0, opacity: 1 }}
                    transition={{ duration: 1.2, ease: "easeOut" }}
                    className="px-6 mb-2 text-center text-[30px] font-bold text-gray-800 bg-gradient-to-r from-[#2a627a]  bg-opacity-100 backdrop-blur-lg p-4 rounded-lg  shadow-lg transition-all duration-300"
                >
                   HikeHealth GS – Provider & Payer Systems
                </motion.div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {/* Feature 1 */}
                    <div className="p-8 h-40 bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-xl rounded-xl flex flex-col items-center justify-between text-center">
                        {/* <FaRegHospital className="text-blue-500 text-3xl mb-3" /> */}
                        <h2 className="text-center font-bold">Data Encryption</h2>
                        <p className="text-gray-600 text-xs mt-2">
                        We protect patient records with advanced encryption techniques, ensuring sensitive data is securely stored and transmitted across systems.
                        </p>
                        <div className="-mb-12">
                            <button
                                onClick={() => navigate('/Services/Provider&PayerSystems/DataEncryption')}
                                className="relative px-6 py-2 text-white bg-[#2a627a] font-semibold rounded-lg shadow-md transition-all duration-300 hover:bg-[#287b9e] hover:shadow-lg active:scale-95
    before:absolute before:inset-0 before:border-2 before:border-white before:scale-x-0 before:origin-left before:transition-transform before:duration-300 hover:before:scale-x-100">
                                Read More
                            </button>
                        </div>


                    </div>

                    {/* Feature 2 */}
                    <div className="p-8 h-40 bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-xl rounded-xl flex flex-col items-center justify-between text-center">
                        {/* <FaShieldAlt className="text-green-500 text-4xl mb-2" /> */}
                        <h2 className="text-lg font-bold">Access Control</h2>
                        <p className="text-gray-600 text-xs mt-2">
                        Implementing role-based access control to ensure that only authorized personnel can access sensitive healthcare data, improving data security.
                        </p>
                        <div className="-mb-12">

                            <button onClick={() => navigate('/Services/Provider&PayerSystems/AccessControl')} className="relative px-6 py-2 text-white bg-[#2a627a] font-semibold rounded-lg shadow-md transition-all duration-300 hover:bg-[#287b9e] hover:shadow-lg active:scale-95
    before:absolute before:inset-0 before:border-2 before:border-white before:scale-x-0 before:origin-left before:transition-transform before:duration-300 hover:before:scale-x-100">Read More</button>
                        </div>
                    </div>

                    {/* Feature 3 */}
                    <div className="p-8 h-40 bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-xl rounded-xl flex flex-col items-center text-center justify-between">
                        {/* <FaFileMedical className="text-red-500 text-4xl mb-1" /> */}
                        <h2 className="text-lg font-bold">Secure Cloud Storage</h2>
                        <p className="text-gray-600 text-xs mt-2">
                        We provide HIPAA-compliant cloud storage solutions, ensuring your medical data is securely stored while remaining accessible to authorized users only.
                        </p>
                        <div className="-mb-12">

                            <button onClick={() => navigate('/Services/Provider&PayerSystems/SecureCloudStorage')} className="relative px-6 py-2 text-white bg-[#2a627a] font-semibold rounded-lg shadow-md transition-all duration-300 hover:bg-[#287b9e] hover:shadow-lg active:scale-95
    before:absolute before:inset-0 before:border-2 before:border-white before:scale-x-0 before:origin-left before:transition-transform before:duration-300 hover:before:scale-x-100">Read More</button>
                        </div>
                    </div>

                    {/* feature-4 */}
                    <div className="p-8 h-40 bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-xl rounded-xl flex flex-col justify-between items-center text-center">
                        {/* <FaClipboardCheck className="text-purple-500 text-6xl mb-2" /> */}
                        <h2 className="text-lg font-bold">Cyber Threat Monitoring </h2>
                        <p className="text-gray-600 text-xs ">
                        Utilizing AI-powered security tools, we continuously monitor systems for potential threats, ensuring that your data remains protected from cyberattacks.
                        </p>
                        <div className="-mb-12">

                            <button onClick={() => navigate('/Services/Provider&PayerSystems/CTM')} className="relative px-6 py-2 text-white bg-[#2a627a] font-semibold rounded-lg shadow-md transition-all duration-300 hover:bg-[#287b9e] hover:shadow-lg active:scale-95
    before:absolute before:inset-0 before:border-2 before:border-white before:scale-x-0 before:origin-left before:transition-transform before:duration-300 hover:before:scale-x-100">Read More</button>
                        </div>
                    </div>
                    {/* feature-5 */}
                    <div className="p-8 h-40 bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-xl rounded-xl flex flex-col items-center justify-between text-center">
                        {/* <FaRocket className="text-purple-500 text-5xl mb-4" /> */}
                        <h2 className="text-lg font-bold"> Patient Privacy Protection</h2>
                        <p className="text-gray-600 text-xs ">
                        Our services ensure full compliance with GDPR and HIPAA regulations, safeguarding patient confidentiality and privacy across all platforms.
                        </p>
                        <div className="-mb-12">

                            <button
                                onClick={() => navigate('/Services/Provider&PayerSystems/Patient')}
                                className="relative px-6 py-2 text-white bg-[#2a627a] font-semibold rounded-lg shadow-md transition-all duration-300 hover:bg-[#287b9e] hover:shadow-lg active:scale-95
    before:absolute before:inset-0 before:border-2 before:border-white before:scale-x-0 before:origin-left before:transition-transform before:duration-300 hover:before:scale-x-100">
                                Read More
                            </button>
                        </div>

                    </div>

                    {/* feature-6 */}
                    <div className="p-8 h-40 bg-gray-300 bg-opacity-70 hover:bg-gray-300 shadow-xl rounded-xl flex flex-col items-center justify-between text-center">
                        {/* <FaUsersCog className="text-pink-500 text-5xl mb-4" /> */}
                        <h2 className="text-lg font-bold">Incident Response & Recovery</h2>
                        <p className="text-gray-600 text-xs ">
                        We develop rapid response strategies to quickly address security breaches and ensure data recovery, minimizing downtime and protecting critical information.
                        </p>
                        <div className="-mb-12">

                            <button onClick={() => navigate('/Services/Provider&PayerSystems/IncidentResponse&Recovery')}
                                className="relative px-6 py-2 text-white bg-[#2a627a] font-semibold rounded-lg shadow-md transition-all duration-300 hover:bg-[#287b9e] hover:shadow-lg active:scale-95
                before:absolute before:inset-0 before:border-2 before:border-white before:scale-x-0 before:origin-left before:transition-transform before:duration-300 hover:before:scale-x-100">Read More</button>
                        </div>
                    </div>


                </div>


                <div><FeaturesSection /></div>
            </div>
            <Footer />
        </>
    );
};

export default HealthcareDataSecurity;
